import { FeedbackContent } from '../models';

export enum FeedbackType {
  SUCCESS,
  WARNING,
  ERROR,
}

export interface Feedback {
  type: FeedbackType;
  header: FeedbackContent;
  timestamp: number;
  description?: string;
  displayed?: boolean;
}

export interface FeedbackState {
  feedbacks: Feedback[];
}
